import { required } from 'vee-validate/dist/rules'
import Component from 'vue-class-component'
import Inquiry from '@/inquiries/models/inquiry'
import { Prop, Vue } from 'vue-property-decorator'
import InquiryContact from '@/inquiries/models/Inquiry-contact'

@Component
export default class InquiryContactDialog extends Vue {
  @Prop({ default: () => [] })
  private pendingContacts!: InquiryContact[]

  private inquiry = new Inquiry()
  private dialog = false

  protected contact() {
    this.$emit('contact', this.inquiry)
    this.close()
  }

  public open(inquiry: Inquiry) {
    this.inquiry = inquiry
    this.dialog = true
  }

  protected close() {
    this.dialog = false
  }
}
